<template>
  <div class="router-wrapper">
    <div class="os-tabs-w">
      <div class="os-tabs-controls os-tabs-complex">
        <div class="nav-item">
          <h1>{{ $t("templates_create.create_new") }}</h1>
        </div>
        <div class="nav-item nav-actions d-none d-sm-block">
          <button type="button" class="button" color="primary" size="xlarge" v-on:cdivck="send">
            {{ $t("general.save") }}
          </button>
        </div>
      </div>
    </div>

    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("general.name") }}</label>
            <input
              :class="{ 'is-invalid': errors.has('name') }"
              name="name"
              v-model="template.name"
              v-validate="'required'"
              class="form-control"
              v-bind:placeholder="$t('general.name')"
              type="text"
            />
          </div>
        </div>
      </div>

      <div class="pipeline-w" style="margin-bottom: 16px;">
        <div class="row">
          <div class="col-6">
            <div class="pipeline pipeline-fullheight white lined-primary" id="selectedCharacteristics">
              <div class="pipeline-header">
                <h5 class="pipeline-name">
                  {{ $t("templates_create.selected_characteristics") }}
                </h5>
              </div>
              <div class="pipeline-wrapper">
                <div class="pipeline-wrapped" id="scrollContainer">
                  <div :list="template.characteristics">
                    <div
                      class="pipeline-item"
                      v-for="c in template.characteristics"
                      :id="'assigned' + c.id"
                      style="cursor: default;"
                      v-bind:key="c.localizedKey"
                    >
                      <div class="pi-controls">
                        <div class="pi-settings">
                          <div class="badge badge-primary float-right">
                            {{ c.category }}
                          </div>
                        </div>
                      </div>
                      <div class="pi-body">
                        <div class="avatar" v-on:click="removeCharacteristic(c)">
                          <i class="fas fa-minus"></i>
                        </div>
                        <div class="pi-info">
                          <div class="h6 pi-name">
                            <span class="h6">{{ c.localizedKey }}</span>
                            - {{ c.unit.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="pipeline pipeline-fullheight white lined-success">
              <div class="pipeline-header">
                <h5 class="pipeline-name">
                  {{ $t("templates_create.available_characteristics") }}
                </h5>
              </div>
              <div class="pipeline-wrapper">
                <div class="pipeline-wrapped" id="scrollContainerAvailable">
                  <div class="pipeline-body">
                    <div
                      class="pipeline-item"
                      v-for="c in characteristics"
                      :id="'available' + c.id"
                      style="cursor: default;"
                      v-bind:key="c.id"
                    >
                      <div class="pi-controls">
                        <div class="pi-settings">
                          <div class="badge badge-primary float-right">
                            {{ c.category }}
                          </div>
                        </div>
                      </div>
                      <div class="pi-body">
                        <div class="avatar" v-on:click="addCharacteristic(c)">
                          <i class="fas fa-plus"></i>
                        </div>
                        <div class="pi-info">
                          <div class="h6 pi-name">
                            <span class="h6">{{ c.localizedKey }}</span>
                            - {{ c.unit.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-danger" role="alert" v-show="errors.has('characteristics')">
        {{ $t("templates_create.select_at_least_one_characteristic") }}
      </div>

      <div class="row">
        <div class="col-lg-12">
          <button type="button" class="button" color="secondary" size="max" v-on:click="send">
            {{ $t("general.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import draggable from "vuedraggable";

export default {
  name: "TemplatesCreate",
  components: {
    draggable
  },
  data() {
    return {
      template: {
        name: null,
        characteristics: [],
        scrollTo: null,
        scrollToAvailable: null
      }
    };
  },
  computed: {
    ...mapState("characteristicsStore", ["characteristics"])
  },
  methods: {
    ...mapActions("characteristicsStore", ["fetch"]),
    ...mapActions("templateStore", ["save"]),
    send() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.save(this.template)
            .then(r => {
              if (r.data.addTemplate === "success") {
                this.$router.push("/templates");
              } else {
                alert(r);
              }
            })
            .catch(e => alert(e));
        }
      });
    },
    addCharacteristic(c) {
      const index = this.characteristics.findIndex(c1 => c1.id === c.id);
      this.characteristics.splice(index, 1);
      this.template.characteristics.push(c);
      this.template.characteristics.sort((c1, c2) => c1.masterSort - c2.masterSort);
      this.scrollTo = c.id;
    },
    removeCharacteristic(c) {
      const index = this.template.characteristics.findIndex(c1 => c1.id === c.id);
      this.template.characteristics.splice(index, 1);
      this.characteristics.push(c);
      this.characteristics.sort((c1, c2) => c1.masterSort - c2.masterSort);
      this.scrollToAvailable = c.id;
    }
  },
  mounted() {
    this.fetch();

    this.$validator.attach({
      name: "characteristics",
      rules: "required",
      getter: () => this.template.characteristics
    });
  },
  watch: {
    template: {
      deep: true,
      handler() {
        this.$validator.validate("characteristics", this.template.characteristics);
      }
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.scrollTo) {
        const options = {
          container: "#scrollContainer",
          easing: "ease-in",
          offset: -60,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };

        this.$scrollTo("#assigned" + this.scrollTo, 500, options);
        this.scrollTo = null;
      }

      if (this.scrollToAvailable) {
        const options = {
          container: "#scrollContainerAvailable",
          easing: "ease-in",
          offset: -60,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };

        this.$scrollTo("#available" + this.scrollToAvailable, 500, options);
        this.scrollToAvailable = null;
      }
    });
  }
};
</script>

<style scoped></style>
